<template>
  <svg :opacity="opacity" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.99996 4.07454C5.8896 3.96029 5.74771 3.92764 5.60582 3.92764H0.891852C0.576537 3.92764 0.166626 4.1235 0.166626 4.43362V14.7655C0.166626 15.092 0.576537 15.5 0.891852 15.5H8.36482C8.68014 15.5 8.8378 15.0756 8.8378 14.7655V7.3063C8.8378 7.1594 8.82203 7.02884 8.71167 6.91459L5.99996 4.07454ZM7.56077 7.35528H5.52699V5.24972L7.56077 7.35528ZM1.42789 14.2106V5.07018H4.42338V7.87758C4.42338 8.20402 4.70716 8.49782 5.02248 8.49782H7.73419V14.2106H1.42789ZM11.7387 3.43798L8.99546 0.597929C8.90086 0.499996 8.80627 0.5 8.68014 0.5H3.96618C3.69816 0.5 3.47744 0.646899 3.47744 0.908052V2.47497C3.47744 2.75244 3.68239 2.96463 3.95041 2.96463C4.21843 2.96463 4.42338 2.73612 4.42338 2.47497V1.46301H7.73419V4.22144C7.73419 4.49892 7.95492 4.72742 8.22293 4.72742H10.8873V10.7666H10.2409C9.97293 10.7666 9.76798 10.9788 9.76798 11.2563C9.76798 11.5337 9.9887 11.7459 10.2409 11.7459H11.4391C11.7072 11.7459 11.8333 11.5011 11.8333 11.2236V3.76442C11.8333 3.66649 11.8175 3.53591 11.7387 3.43798ZM8.68014 1.64255L10.7139 3.76442H8.68014V1.64255Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'copyIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      },
      opacity: {
        type: Number,
        default: 1,
      }
    }
  }
</script>

<style scoped>
  svg:hover {
    opacity: 1!important;
  }
</style>
